import { NAME_SPACE as ns } from './constants';

export const CLEAR = `CLEAR`;

export const SET_CHECKING_FOR_IMAGES = `${ns}_SET_CHECKING_FOR_IMAGES`;

export const SET_IMAGE_FLAGS = `${ns}_SET_IMAGE_FLAGS`;
